module.exports = __webpack_public_path__ + "static/eye-hovered-44bb4d1c8a184792dcda6fb38231ec65.svg";